import DirectlyOrderReport from './directly_order_report.vue';

export default DirectlyOrderReport;
